// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"866":"736fbd2c","917":"1bd603df"}[chunkId] + ".chunk.js";
};